<template>
  <van-overlay :show="visible" @click="handleOverlayClick" z-index="999999">
    <div class="carousel-container" @click.stop>
      <!-- 关闭按钮 -->
      <!-- <van-icon name="cross" class="close-btn" @click="handleClose" /> -->

      <!-- 轮播组件 -->
      <van-swipe
        ref="swipe"
        :autoplay="5000"
        :show-indicators="true"
        class="carousel-swipe"
        :loop="false"
        indicator-color="#5E5E5E"
        @change="handleSwipeChange"
      >
        <van-swipe-item v-for="(item, index) in carouselData" :key="index">
          <div class="carousel-item">
            <!-- 手机截图区域 -->
            <div class="phone-mockup">
              <div class="phone-frame">
                <img :src="item.image" :alt="item.title" class="phone-image" />
              </div>
            </div>

            <!-- 底部文案区域 -->
            <div class="content-area">
              <div class="title">{{ item.title }}</div>
              <p class="description">{{ item.description }}</p>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>

      <!-- 开始按钮 -->
      <van-button
        color="#000000"
        style="margin: 32px; height: 48px; width: calc(100dvw - 64px);"
        block
        round
        :disabled="!isCompleted"
        @click="handleStart"
      >
        立即开启
      </van-button>
    </div>
  </van-overlay>
</template>

<script>
import Vue from "vue";
import { Overlay, Swipe, SwipeItem, Button, Icon } from "vant";
import { updateUserVisitStatus } from "@/api/theApi";
Vue.use(Overlay);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Icon);

export default {
  name: "WelcomeCarousel",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    needComplete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
      isCompleted: this.needComplete ? false : true,
      carouselData: [
        {
          title: "欢迎来到金声玉亮",
          description:
            "​AI老师全自动操盘策略，问答助手实时解答，收益进展透明同步——您坐享其成。​",
          image: require("@/assets/img/help_1.png"),
        },
        {
          title: "收益算力一屏控",
          description:
            "​实时查收益，管理算力账户，代码部署，坐享AI创造的回报可视化！​",
          image: require("@/assets/img/help_2.png"),
        },
        {
          title: "私有化策略？云端部署自动跑",
          description:
            "​私有策略一键云端托管，AI 7×24小时精准执行，打造专属赚钱引擎。​",
          image: require("@/assets/img/help_3.png"),
        },
        {
          title: "策略迷茫？一键订阅老师",
          description:
            " ​看AI老师自动分析行情与策略，轻松追踪收益潜力，躺着也能学投资！​",
          image: require("@/assets/img/help_4.png"),
        },
        {
          title: "你的专属智能答疑管家",
          description: "随时问AI投资问题，秒获专业解答，赚钱路上有问必答！​",
          image: require("@/assets/img/help_5.png"),
        },
        {
          title: "更多问题详情咨询客服",
          description: "添加客服微信可获得1对1系统使用帮助及更多福利\n",
          image: require("@/assets/img/help_6.png"),
        },
      ],
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // 确保DOM渲染完成后再初始化swipe
          if (this.$refs.swipe) {
            this.$refs.swipe.resize();
          }
        });
      }
    },
    needComplete(newVal) {
      this.isCompleted = !newVal;
    },
  },
  methods: {
    handleSwipeChange(index) {
      this.currentIndex = index;
      if (index === this.carouselData.length - 1) {
        this.isCompleted = true;
      }
    },
    handleClose() {
      updateUserVisitStatus({
        type: "1"
      });
      this.$emit("close");
    },
    handleOverlayClick() {
      // 点击遮罩层不关闭，只有点击关闭按钮才关闭
    },
    handleStart() {
      this.$emit("start");
      this.handleClose();
    },
  },
};
</script>

<style lang="less" scoped>
.carousel-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f5f7;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100dvh;
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  font-size: 20px;
  color: #000000;
  z-index: 10000;
  background: transparent;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-swipe {
  flex: 1;
  height: calc(100dvh - 112px - env(safe-area-inset-bottom));
  width: 100dvw;

  .van-swipe__indicators {
    .van-swipe__indicator:not(.van-swipe__indicator--active) {
      background: #d9d9d9;
    }
  }
}

.carousel-item {
  height: calc(100dvh - 112px - env(safe-area-inset-bottom));
  width: 100dvw;
  display: flex;
  flex-direction: column;
  background: #f5f5f7;
}

.phone-mockup {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 68px auto 0px;
}

.phone-frame {
  position: relative;
  width: 100%;
}

.phone-image {
  width: 262px;
}

.content-area {
  margin: 0 20px;
  position: relative;
  top: -64px;
  text-align: center;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title {
  font-family: PingFangSC-Medium;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.5;
  text-align: center;
  color: #000000;
}

.description {
  margin-top: 8px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.5;
  text-align: center;
  color: #00000099;
  height: 45px;
}

/* 移除默认的 padding 和 margin */
* {
  box-sizing: border-box;
}
</style>
<style lang="less">
.carousel-swipe {
  .van-swipe__indicators {
    .van-swipe__indicator:not(.van-swipe__indicator--active) {
      background: #d9d9d9;
    }
  }
}
</style>
